(() => {
  const initialize = () => {
    document.querySelectorAll('.mojis-store-header nav a').forEach(link => {
      if (new URL(link.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
    });
    document.querySelectorAll('.mojis-store-menu').forEach(menu => {
      if (menu.dataset.initialized === 'true') return;
      menu.dataset.initialized = 'true';
      const summary = menu.querySelector('summary');
      const close = restore => {
        if (!menu.open) return;
        menu.open = false;
        if (restore) summary?.focus();
      };
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); }
      });
      document.addEventListener('pointerdown', event => {
        if (!menu.contains(event.target)) close(false);
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(false)));
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) close(false); }, 0));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
